import { j as s } from "./AccesRecoveryIcon-CUPieIxT.js";
const o = () => /* @__PURE__ */ s.jsxs("svg", { viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ s.jsx("path", { d: "M40 20c0 11.046-8.954 20-20 20S0 31.046 0 20 8.954 0 20 0s20 8.954 20 20", fill: "#8F8FEF" }),
  /* @__PURE__ */ s.jsx(
    "path",
    {
      d: "m20.41 3.167-.024.04L24.549 24.5l10.337 3.75zm-.937.666L5 28.917h.012l16.53-14.479zM34.97 29.208l-20.461-7.416-8.498 7.416z",
      fill: "#fff"
    }
  )
] });
export {
  o as G
};
